import { Injectable } from '@angular/core';
import { GraphqlService } from '@app/core/services/graphql.service';
import { markAsReadMutation, markAsUnreadMutation } from '@app/pcs/data/mark-read-status.mutations';

@Injectable()
export class MarkReadStatusDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  markAsRead(dossierVersions) {
    return this.graphqlService.mutation(markAsReadMutation, {dossierVersions});
  }

  markAsUnread(dossierVersions) {
    return this.graphqlService.mutation(markAsUnreadMutation, {dossierVersions});
  }
}
